import axios from "axios";
import { API_END_POINTS } from "../../API_END_POINTS";

const loginUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.login}`;
const verifyOtpUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.VERIFY_OTP}`;
const forgotPasswordUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.FORGOT_PASSWORD}`;
const resetPasswordUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.RESET_PASSWORD}`; // Add the reset password endpoint

// Login user function
const loginUserService = async (email, password, lang) => {
  try {
    const response = await axios.post(
      loginUrl,
      {
        email,
        password,
      },
      {
        headers: {
          lang: lang || "de",
        },
      }
    );
    return response; // Return the response containing user and token
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while logging in.";
    console.error("Error logging in:", errorMessage);
    throw new Error(errorMessage); // Throw custom error message
  }
};

// OTP verification function
const verifyOtpService = async (email, otp) => {
  try {
    const response = await axios.post(verifyOtpUrl, {
      email,
      otp,
    });
    return response; // Return the response upon successful verification
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while verifying OTP.";
    console.error("Error verifying OTP:", errorMessage);
    throw new Error(errorMessage); // Throw custom error message
  }
};

// Forgot password function
const forgotPasswordService = async (email) => {
  try {
    const response = await axios.post(forgotPasswordUrl, {
      email,
    });
    return response; // Return the response upon successful request
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while sending forgot password request.";
    console.error("Error in forgot password:", errorMessage);
    throw new Error(errorMessage); // Throw custom error message
  }
};

const resetPasswordService = async (email, password) => {
  try {
    const response = await axios.post(resetPasswordUrl, {
      email, // Email address
      password, // New password
    });
    return response; // Return the response upon successful reset
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while resetting the password.";
    console.error("Error resetting password:", errorMessage);
    throw new Error(errorMessage); // Throw custom error message
  }
};

export {
  loginUserService,
  verifyOtpService,
  forgotPasswordService,
  resetPasswordService,
};
